import api from "./apiLogisticsTool.js";

export default {
  GetProcedureParametersById(id) {
    return api.get("ProceduresParameters/GetProcedureParametersById/" + id);
  },

  GetProcedureParametersByProcedureId(ProcedureId) {
    return api.get(
      "ProceduresParameters/GetProcedureParametersByProcedureId/" + ProcedureId
    );
  },

  GetProceduresParametersByIdAndName(id, name) {
    return api.get(
      "ProceduresParameters/GetProceduresParametersByIdAndName/" +
        id +
        "/" +
        name
    );
  },

  InsertProceduresParameters(pp) {
    return api.post("ProceduresParameters/InsertProceduresParameters", pp);
  },

  EditProceduresParameters(pp) {
    return api.put("ProceduresParameters/EditProceduresParameters", pp);
  },

  DeleteProceduresParamaters(id) {
    return api.delete("ProceduresParameters/DeleteProceduresParamaters", id);
  }
};
